import moment from 'moment'
import PropTypes from 'prop-types'
import { PureComponent } from 'react'

import { cn } from '@repo/utils'

import { ChildrenSchema } from 'utils'

import Day from './Day'

import styles from './index.css'

class MonthCalendar extends PureComponent {
  getDayEvents = (day) => this.props.events.filter((event) => moment(event.datetime).isSame(day, 'day'))

  renderDays() {
    const month = moment(this.props.month)
    const today = moment().startOf('day')

    const firstDay = month.clone().startOf('month').startOf('week')
    const lastDay = month.clone().endOf('month').endOf('week')

    // Something weird with moment that is not moving to the very first day of the week
    // Is actually imposible to test this
    /* istanbul ignore next */
    if (firstDay.day() > 0) {
      const fixedDays = -firstDay.day()
      firstDay.add(fixedDays, 'days')
      lastDay.add(fixedDays, 'days')
    }

    const days = []
    while (lastDay.diff(firstDay, 'days', true) >= 0) {
      const value = firstDay.valueOf()
      const readOnly = !firstDay.isSame(month, 'month')

      days.push(
        <Day
          key={value}
          active={firstDay.isSame(today, 'day')}
          className={readOnly ? styles.day : styles.activeDay}
          day={firstDay.format('D')}
          events={this.getDayEvents(firstDay)}
          highlight={firstDay.format('d') === '0'}
          onAddEvent={this.props.onAddEvent}
          onEditEvent={this.props.onEditEvent}
          onRemoveEvent={this.props.onRemoveEvent}
          readOnly={readOnly}
          value={value}
        />,
      )
      firstDay.add(1, 'days')
    }

    return days
  }

  render() {
    const { className } = this.props

    return (
      <div className={cn(className, styles.wrapper)}>
        <div className={styles.container}>
          <div className={styles.titles}>
            {moment.weekdays().map((day) => (
              <div key={day}>{day}</div>
            ))}
          </div>
          <div className={styles.body}>{this.renderDays()}</div>
        </div>
      </div>
    )
  }
}

const CalendarEventSchema = PropTypes.shape({
  id: PropTypes.string.isRequired,
  datetime: PropTypes.number.isRequired,
  title: PropTypes.string.isRequired,

  categoryId: PropTypes.number,
  doing: PropTypes.bool,
  done: PropTypes.bool,
  icon: ChildrenSchema,
  todo: PropTypes.bool,
})

MonthCalendar.propTypes = {
  events: PropTypes.arrayOf(CalendarEventSchema).isRequired,
  onAddEvent: PropTypes.func.isRequired,
  onEditEvent: PropTypes.func.isRequired,
  onRemoveEvent: PropTypes.func.isRequired,

  className: PropTypes.string,
  month: PropTypes.number,
}

MonthCalendar.defaultProps = {
  className: '',
  month: moment().valueOf(),
}

export default MonthCalendar
